import classes from "./KnowledgeChecksContainer.module.css";
import KnowledgeCheck from "./KnowledgeCheck";
import {chart_knowledgeChecks} from "../../connections";
import {KnowledgeCheckProps} from "./KnowledgeCheck";
import {useEffect, useState} from "react";

type ApiResponse = { enabled:boolean, data: KnowledgeCheckProps[]}
export default function KnowledgeChecksContainer(){
    const [data, setData] = useState<KnowledgeCheckProps[]>([])
    const [enabled,setEnabled] = useState(false);
    useEffect(() => {
        const getData = async () => {
            const response: ApiResponse = await chart_knowledgeChecks();
            setData(response.data);
            setEnabled(response.enabled)
        }
        getData();
    }, []);
    return enabled ? (
        <div className={classes.Container}>
            <div className={classes.knowledgeCheckContainer}>
                <p className={classes.Title}>How did the learner perform on the knowledge checks?</p>
                <div className={classes.girdContainer}>
                    {
                        data.map((item: KnowledgeCheckProps) => (
                            <KnowledgeCheck 
                                knowledge_check_name={item.knowledge_check_name} 
                                avg_time_ms={item.avg_time_ms} 
                                percentage_correct={item.percentage_correct} 
                                percentage_incorrect={item.percentage_incorrect}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    ) : <></>
}